import React, { useState, useEffect } from 'react';
import { useSelector } from "react-redux";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { loadStripe } from "@stripe/stripe-js";

const AddMoney = () => {
  const [selectedTannits, setSelectedTannits] = useState(null);
  const [customTannits, setCustomTannits] = useState("");
  const [paymentMethod, setPaymentMethod] = useState("Paypal");
  const [isProcessing, setIsProcessing] = useState(false);
  const [reference, setReference] = useState("");
  const [paymentType, setPaymentType] = useState("one-time");
  const [selectedPlan, setSelectedPlan] = useState(null);
  const apiUrl = process.env.REACT_APP_API_URL;
  const user = useSelector((state) => state.auth.user);
  const { id: userId, country } = user.claims;
  const base_Url = process.env.REACT_APP_API_URL;
  const navigate = useNavigate();
  // Check if user is from Tunisia
  const isTunisianUser = "Tunisia";{
  const API_KEY = 'eb180a676331c1fe626a8ede';


  // Payment methods array - conditionally include Konnect for Tunisian users
  const paymentMethods = [
    "Stripe", 
    "Paypal", 
    "GoCardless", 
    "Investment Broker",
    ...(isTunisianUser ? ["Konnect"] : [])
  ];

  // Subscription plans data
  const subscriptionPlans = [
    {
      id: "classic",
      name: "Classic (Free)",
      price: 0,
      interval: "month",
      tannits: 0,
      features: [
        "Limited EcoVest features",
        "Standard fees",
        "No secondary market"
      ]
    },
    {
      id: "ecovest",
      name: "EcoVest Unlimited",
      price: 40,
      interval: "month",
      tannits: 400,
      features: [
        "Full EcoVest gamification",
        "reduced fees",
        "No secondary market"
      ],
      popular: true
    },
    {
      id: "pro",
      name: "Pro Investor",
      price: 400,
      interval: "month",
      tannits: 4000,
      features: [
        "Complete EcoVest experience",
        "lowest fees",
        "Secondary market",
        "Advanced analytics and reports"
      ]
    }
  ];

  const handleRadioChange = (value) => {
    setSelectedTannits(value);
    setCustomTannits("");
    setSelectedPlan(null);
  };

  const handleCustomChange = (e) => {
    setSelectedTannits(null);
    setCustomTannits(e.target.value);
    setSelectedPlan(null);
  };

  const handlePlanSelect = (plan) => {
    setSelectedPlan(plan);
    setSelectedTannits(null);
    setCustomTannits("");
    setPaymentType("subscription");
  };

  const handlePaymentTypeChange = (type) => {
    setPaymentType(type);
    setSelectedPlan(null);
    setSelectedTannits(null);
    setCustomTannits("");
  };

  const handleReferenceChange = (e) => {
    setReference(e.target.value);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (paymentType === "one-time") {
      const tannitsTopped = selectedTannits || customTannits;

      if (!tannitsTopped || tannitsTopped <= 0) {
        alert("Please enter a valid amount of Tannits");
        return;
      }

      if (paymentMethod === "Investment Broker" && !reference) {
        alert("Please enter a reference for Investment Broker payment");
        return;
      }

      const transaction = {
        TannitsTopped: parseInt(tannitsTopped, 10),
        Price: parseFloat(tannitsTopped) * 10,
        CurrencyId: 1,
        Description: "Top-up transaction",
        InvestorId: userId,
        CreatedAt: new Date().toISOString(),
        Vested: false,
      };
      sessionStorage.setItem('currentTransaction', JSON.stringify(transaction));
      setIsProcessing(true);

      try {
        if (paymentMethod === "Stripe") {
          const response = await axios.post(
            `${apiUrl}/payment/create-stripe-session`,
            {
              price: transaction.Price,
              description: transaction.Description,
            }
          );
          const { id } = response.data;
          const stripe = await loadStripe("pk_test_51RB5LYPBzcrWLWYLheaSSVZeMr5PMfi8G3Tro3qAIRejyop9UyBHBkwQ0vOoSBUuYQ3tBlwxlER9xLB2rmVQM9tZ00h8h5YOME");
          await stripe.redirectToCheckout({ sessionId: id });
        }
        else if (paymentMethod === "Paypal") {
          const response = await axios.post(
            `${apiUrl}/payment/create-paypal-payment`,
            {
              price: transaction.Price,
              description: transaction.Description,
            }
          );
          window.location.href = response.data;
        }
        else if (paymentMethod === "Konnect") {
        const responsecurrency = await fetch(`${base_Url}/currency/48`);
        const datacurrency = await responsecurrency.json();
        var amountInTND = 0;
        if (datacurrency.status.code === 1 && datacurrency.data.length > 0) {
           amountInTND = Math.round(transaction.Price * datacurrency.data[0].convertionRateGPB * 100);
        }
          try {
          const responses = await fetch(
              `https://v6.exchangerate-api.com/v6/${API_KEY}/pair/GBP/TND`
            );
            
            const datas = await responses.json();
            
            if (datas.result === 'success') {
              amountInTND = Math.round(transaction.Price * datas.conversion_rate * 100);
            }
          } catch (error) {}
          const response = await axios.post(
            `${base_Url}/payment/init-konnect-payment`,
            {
              receiverWalletId: "683412a3d9dd82b885958e42",
              token: "TND",
              amount: amountInTND,
              type: "immediate",
              description: transaction.Description,
              acceptedPaymentMethods: ["wallet", "bank_card", "e-DINAR"],
              lifespan: 10,
              checkoutForm: true,
              addPaymentFeesToAmount: true,
              firstName: user.firstName || "User",
              lastName: user.lastName || "Customer",
              phoneNumber: user.phone || "00000000",
              email: user.email || "user@example.com",
              firstName:"Saif",
              lastName: "Essaidi",
              phoneNumber: "51000000",
              email: "test@tannit.uk",
              orderId: `TANNIT-${Date.now()}`,
              webhook: `${apiUrl}/payment/konnect-webhook`
            }
          );
          
          window.location.href = response.data.payUrl;
        }
        else if (paymentMethod === "Investment Broker") {
          await axios.post(`${apiUrl}/payment/create-broker-payment`, {
            ...transaction,
            reference
          });
          navigate("/topupSuccess");
        }
      } catch (error) {
        setIsProcessing(false);
        console.error("Payment error:", error);
        navigate("/topupFailer");
      }
    } else {
      // Subscription payment logic
      if (!selectedPlan) {
        alert("Please select a subscription plan");
        return;
      }

      setIsProcessing(true);
      try {
        if (paymentMethod === "Stripe") {
          const response = await axios.post(
            `${apiUrl}/payment/create-stripe-subscription`,
            {
              planId: selectedPlan.id,
              customerId: userId,
              tannits: selectedPlan.tannits,
              price: selectedPlan.price
            }
          );
          const { sessionId } = response.data;
          const stripe = await loadStripe("pk_test_51RB5LYPBzcrWLWYLheaSSVZeMr5PMfi8G3Tro3qAIRejyop9UyBHBkwQ0vOoSBUuYQ3tBlwxlER9xLB2rmVQM9tZ00h8h5YOME");
          await stripe.redirectToCheckout({ sessionId });
        }
        else if (paymentMethod === "Paypal") {
          const response = await axios.post(
            `${apiUrl}/payment/create-paypal-subscription`,
            {
              planId: selectedPlan.id,
              price: selectedPlan.price
            }
          );
          window.location.href = response.data.approvalUrl;
        }
      } catch (error) {
        setIsProcessing(false);
        console.error("Subscription error:", error);
        alert("Subscription setup failed. Please try again.");
      }
    }
  };

  const PaymentMethodSection = ({
    paymentMethod,
    setPaymentMethod,
    reference,
    handleReferenceChange,
    isProcessing,
    navigate,
    handleSubmit
  }) => (
    <>
      <div className="col-12 new-radio-2 mt-4">
        <h3>Payment method</h3>
        <div className="mr-1 row d-flex">
          {paymentMethods.map((method) => (
            <div
              key={method}
              className={`form-radio-check2 col ${
                paymentMethod === method ? "selected" : ""
              }`}
              onClick={() => setPaymentMethod(method)}
              style={{
                cursor: "pointer",
                border:
                  paymentMethod === method
                    ? "2px solid #007bff"
                    : "1px solid #ccc",
                padding: "10px",
                borderRadius: "5px",
              }}
            >
              <h4>
                <span>
                  <img
                    src={`assets/icons/${method.toLowerCase()}.svg`}
                    alt=""
                    onError={(e) => {
                      e.target.src = `assets/icons/default-payment.svg`;
                    }}
                  />
                </span>
                {method}
              </h4>
            </div>
          ))}
        </div>
      </div>

      {paymentMethod === "Investment Broker" && (
        <div className="col-12 not-sec mt-4">
          <h5>Payment Reference</h5>
          <p>Enter your Investment Broker payment reference</p>
          <div className="input-group mb-3">
            <input
              type="text"
              className="form-control"
              placeholder="Payment reference"
              value={reference}
              onChange={handleReferenceChange}
              required
            />
          </div>
        </div>
      )}

      <div className="verification-btns d-flex mt-4">
        <button
          type="button"
          className="btn radio-btn-1 btn-outline-secondary"
          onClick={() => navigate(-1)}
        >
          Cancel
        </button>
        <button
          type="submit"
          className="btn radio-btn-2 btn-primary"
          disabled={isProcessing}
        >
          {isProcessing ? "Processing..." : "Confirm Payment"}
        </button>
      </div>
    </>
  );

  return (
    <div className="App">
      <section className="main-cont-comp">
        <div className="container">
          <div className="row">
            <div className="col-lg-12 main-comp-sec">
              <h3>Add Money to Your Pot: Boost Your Savings with Contributions</h3>
              
              {/* Payment Type Toggle */}
              <div className="mb-4">
                <div className="btn-group w-100" role="group">
                  <button
                    type="button"
                    className={`btn ${paymentType === "one-time" ? "btn-primary" : "btn-outline-primary"}`}
                    onClick={() => handlePaymentTypeChange("one-time")}
                  >
                    One-Time Payment
                  </button>
                  <button
                    type="button"
                    className={`btn ${paymentType === "subscription" ? "btn-primary" : "btn-outline-primary"}`}
                    onClick={() => handlePaymentTypeChange("subscription")}
                  >
                    Subscription
                  </button>
                </div>
              </div>

              {paymentType === "one-time" ? (
                <form onSubmit={handleSubmit}>
                  <div className="col-12">
                    <div className="mr-1 row d-flex">
                      {/* Tannit Options */}
                      {[
                        { value: 120, price: "1200.00£" },
                        { value: 320, price: "3200.00£" },
                        { value: 1500, price: "15000.00£" },
                      ].map(({ value, price }) => (
                        <div
                          key={value}
                          className={`form-radio-check col ${
                            selectedTannits === value ? "selected" : ""
                          }`}
                          onClick={() => handleRadioChange(value)}
                          style={{
                            cursor: "pointer",
                            border:
                              selectedTannits === value
                                ? "2px solid #007bff"
                                : "1px solid #ccc",
                            padding: "10px",
                            borderRadius: "5px",
                          }}
                        >
                          <h4>
                            <span>
                              <img src="assets/icons/Tannit coin.svg" alt="" />
                            </span>
                            {value}
                          </h4>
                          <p>{price}</p>
                        </div>
                      ))}

                      {/* Custom Amount */}
                      <div className="col-12 not-sec mt-4">
                        <h5>Custom amount</h5>
                        <p>Amount of TANNIT desired</p>
                        <div className="input-group mb-3">
                          <div className="input-group-prepend">
                            <span className="input-group-text">
                              <img src="assets/icons/Tannit coin.svg" alt="" />
                            </span>
                          </div>
                          <input
                            type="number"
                            className="form-control"
                            placeholder="Number of TANNIT"
                            value={customTannits}
                            onChange={handleCustomChange}
                            min="1"
                          />
                          <div className="input-group-append">
                            <span className="input-group-text">
                              = {customTannits * 10 || 0}£
                            </span>
                          </div>
                        </div>
                        <label className="form-label note">
                          Note: 1 TANNIT = 10£
                        </label>
                      </div>
                    </div>
                  </div>

                  {/* Payment Methods and Submit */}
                  <PaymentMethodSection 
                    paymentMethod={paymentMethod}
                    setPaymentMethod={setPaymentMethod}
                    reference={reference}
                    handleReferenceChange={handleReferenceChange}
                    isProcessing={isProcessing}
                    navigate={navigate}
                    handleSubmit={handleSubmit}
                  />
                </form>
              ) : (
                <div className="subscription-plans">
                  <div className="row row-cols-1 row-cols-md-3 g-4">
                    {subscriptionPlans.map((plan) => (
                      <div className="col" key={plan.id}>
                        <div className={`card h-100 pricing-card ${selectedPlan?.id === plan.id ? "border-primary border-2" : "border-light"} ${plan.popular ? "popular-plan" : ""}`}>
                          {plan.popular && (
                            <span className="badge bg-primary popular-badge">Popular</span>
                          )}
                          <div className="card-body p-4 justify-content-between d-flex flex-column">
                            <div>
                            <h5 className="card-title text-muted text-uppercase mb-3">{plan.name}</h5>
                            <h2 className="mb-3">
                              £{plan.price}<small className="text-muted fw-light">/{plan.interval}</small>
                            </h2>
                            <p className="text-muted mb-4">{plan.tannits} TANNITs per {plan.interval}</p>
                            <ul className="list-unstyled mb-4">
                              {plan.features.map((feature, index) => (
                                <li key={index} className="mb-2">
                                  <i className="bi bi-check-circle-fill text-primary me-2"></i>
                                  {feature}
                                </li>
                              ))}
                            </ul>
                            </div>
                            <button
                              type="button"
                              className={`btn ${selectedPlan?.id === plan.id ? "btn-primary" : "btn-outline-primary"} w-100`}
                              onClick={() => handlePlanSelect(plan)}
                            >
                              {selectedPlan?.id === plan.id ? "Selected" : "Select Plan"}
                            </button>
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>

                  {selectedPlan && (
                    <form onSubmit={handleSubmit} className="mt-5">
                      <PaymentMethodSection 
                        paymentMethod={paymentMethod}
                        setPaymentMethod={setPaymentMethod}
                        reference={reference}
                        handleReferenceChange={handleReferenceChange}
                        isProcessing={isProcessing}
                        navigate={navigate}
                        handleSubmit={handleSubmit}
                      />
                    </form>
                  )}
                </div>
              )}
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}};

export default AddMoney;